import React, { useState } from 'react'
import { addDoc, collection } from 'firebase/firestore';
import { db } from './firebase';

function Bottom() {


  const [email, setemail] = useState('')

  const add=async()=>{
    try{
      await addDoc(collection(db, 'chat'),{
        email : email
      })
    }catch(e){
      console.log(e.message);
    }
  }
 
  return (
    <div className='reach'>
      <div className='bttmsh'> </div>
      <div className='reach_body'>
        <h3>GlobalExpress Courier Company</h3>
        <p>GlobalExpress Courier Company was established to cater for domestic 
        and commercial shipping world wide with our 
        headquartered in and Branches all over the world.</p>

        <h4>For enquiries, send mails to</h4>
        <p>support@GlobalExpresscompany.org</p>

        <h3>You can also contact us at</h3>
        <p>Consultant Office: 163-10 Sareung-ro, Jingeon-eup, Namyangju-si, Gyeonggi-do, South Korea</p>
      </div>

      <div className='reach_body'>
        <h3>SUBSCRIBE TO OUR NEWSLETTER</h3>
        <input onChange={((e)=>setemail(e.target.value))} placeholder='examples@gmail.com'/>
        <span onClick={add}>Subscribe</span>
      </div>
    </div>
  )
}

export default Bottom